import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PredictionCreate = lazy(() =>
  import("@predictions/PredictionCreateNRO").then((module) => ({
    default: module.PredictionCreateChurnNRO,
  }))
);

export const engagementPredictionsNewChurnNRO: NavigationRoutingObject = {
  section: "analytics",
  Component: PredictionCreate,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("predictions-create-churn-heading", "Create Churn Prediction"),
  pageNameForTracking: () => "Create Churn Prediction",
  getDeveloperNavigationAllowed: ({ predictionFeatures, hasPermission }) => {
    return (
      predictionFeatures.churn.ENABLED &&
      hasPermission("appGroup", { permission: "viewPredictions" }) &&
      hasPermission("appGroup", { permission: "editPredictions" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/predictions/predictions/:appGroupId",
};
